import {Component, OnInit} from '@angular/core';
import {MsalService} from "@azure/msal-angular";
import {AuthService} from "../../services/auth.service";

@Component({
    selector: 'mvp-auth-microsoft-button',
    templateUrl: './microsoft-button.component.html',
    styleUrls: ['./microsoft-button.component.scss'],
    standalone: false
})
export class MicrosoftButtonComponent implements OnInit {

  error?: string;

  constructor(
    private readonly msalService: MsalService,
    private readonly authService: AuthService,
  ) {
  }

  ngOnInit() {
    // Handle redirect result when component loads
    this.msalService.handleRedirectObservable().subscribe({
      next: (result) => {
        if (result && result.idToken) {
          console.log('Redirect login successful:', result);
          try {
            this.authService.xLogin({
              provider: "MICROSOFT",
              providerToken: result.idToken,
              selectedStation: undefined
            });
          } catch (error) {
            console.error('xLogin error after redirect:', error);
            this.error = (error as Error).message || 'Hiba történt a Microsoft bejelentkezés során.';
          }
        }
      },
      error: (err) => {
        console.error('Redirect login error:', err);
        this.error = err.message || 'Hiba történt a Microsoft bejelentkezés során.';
      }
    });
  }

  loginClick() {
    console.log('ms login redirect');
    this.error = undefined; // Clear any previous errors
    
    this.msalService.loginRedirect({
      prompt: "select_account",
      scopes: ["openid", "profile", "User.Read"]
    });
  }

  // private loginSuccess(result: AuthenticationResult) {
  //   console.log('loginResult:', result);
  // }
}
